import React from "react";
import config from "../../../config/config";
import { getBoxesCount } from "../../inventory/InventoryHelper";
import {
  getInquiryDetails,
  generateInvoice,
} from "../../../functions/invoiceGenerator";
import { getUserInfoFromSession } from "../../../adapters/session/localSessionAdapter";

export function EstimateMoveDate(props) {
  const { moveDateObj, moveDateFlexible, handleMoveDateUpdate, disableEdit } =
    props;
  const JSX = (
    <div className="move-date-container">
      <div>
        <img
          className="mr-2"
          src={
            config.customerPortal +
            "includes/img/customerDashboard/move_date.png"
          }
          alt="..."
        />

        <span className="font-size-md mb-0">
          {`${moveDateObj.format("MMM Do YYYY")} at ${moveDateObj.format(
            "h:mm a"
          )}`}
        </span>
        {disableEdit === false && (
          <small
            onClick={handleMoveDateUpdate}
            className="arrow_bottom mb-0 pointer"
          >
            <span className="pointer">
              <img
                className="ml-2"
                src={
                  config.customerPortal +
                  "includes/img/customerDashboard/pencil_edit.png"
                }
                alt="..."
              />
            </span>
          </small>
        )}
      </div>
      {disableEdit === false && moveDateFlexible === "1" && (
        <div
          className="custom-checkbox pointer my-lg-2 my-xl-0"
          data-toggle="modal"
          data-target="#dateModal_E91098"
        >
          <input
            type="checkbox"
            checked={true}
            className="custom-control-input"
          />
          <span className="font-size-sm custom-control-label">Is flexible</span>
        </div>
      )}
    </div>
  );
  return JSX;
}

export function MoveItemsInfo(props) {
  const {
    propertySize,
    callback,
    totalItems,
    items,
    serviceType,
    inventoryData,
    distance,
  } = props;

  const boxesCount =
    items !== null && serviceType === "relocation"
      ? getBoxesCount(inventoryData)
      : 0;

  const JSX = (
    <div className="d-flex justify-content-between align-items-center">
      <span className="py-1">
        <img
          className="mr-2"
          src={
            config.customerPortal +
            "/includes/img/customerDashboard/property_size.png"
          }
          alt="..."
        />
        <span className="font-size-md mb-0">{propertySize}</span>
      </span>
      {callback === "0" && (
        <>
          <span className="py-1 ">
            <img
              className="mr-2"
              src={
                config.customerPortal +
                "/includes/img/customerDashboard/items.png"
              }
              alt="..."
            />
            <span className="font-size-md mb-0">
              {parseInt(totalItems) - parseInt(boxesCount)}
            </span>
          </span>
          <span className="py-1 ">
            <img
              className="mr-2"
              src={
                config.customerPortal +
                "/includes/img/customerDashboard/total_items.png"
              }
              alt="..."
            />
            <span className="font-size-md mb-0">{boxesCount}</span>
          </span>
        </>
      )}

      <span className="py-1 ">
        <img
          className=" mr-2"
          src={
            config.customerPortal +
            "/includes/img/customerDashboard/distance.png"
          }
          alt="..."
        />
        <span className="font-size-md mb-0">{distance}</span>
      </span>
    </div>
  );
  return JSX;
}

export const downloadInqury = (estimateData) => {
  const userData = getUserInfoFromSession();
  const name = userData["customerName"];
  const phone = userData["phone"];
  const email = userData["email"];
  const alternatePhone = userData["alternatePhone"];
  const inquiryDetails = getInquiryDetails(estimateData, name, email, phone, alternatePhone);
  generateInvoice(estimateData["estimate_id"], inquiryDetails, "inquiry");
  return;
};

export function AddressInfo(props) {
  // move address info component
  const { fromAddress, toAddress, estimateId, estimateDetails } = props;

  const formatAddressData = (data) => {
    if (data !== undefined && data !== "" && data !== null) {
      return data;
    }
    return "";
  };
  const getFromAddress = (addressInfo = null) => {
    if (addressInfo === null || addressInfo === undefined) {
      return props.movingFrom;
    }
    let fromAddress = [];
    let address = formatAddressData(addressInfo["fromAddress"]);
    let locality = formatAddressData(addressInfo["fromLocality"]);
    let city = formatAddressData(addressInfo["fromCity"]);
    let state = formatAddressData(addressInfo["fromState"]);
    let pincode = formatAddressData(addressInfo["pincode"]);
    if (address !== "") {
      fromAddress.push(address);
    }
    if (locality !== "") {
      fromAddress.push(locality);
    }
    if (city !== "") {
      fromAddress.push(city);
    }
    if (state !== "") {
      fromAddress.push(state);
    }
    if (pincode !== "") {
      fromAddress.push(pincode);
    }
    return fromAddress.join(", ");
  };
  const getToAddress = (addressInfo = null) => {
    if (addressInfo === null || addressInfo === undefined) {
      return props.movingTo;
    }
    let toAddress = [];
    let address = formatAddressData(addressInfo["toAddress"]);
    let locality = formatAddressData(addressInfo["toLocality"]);
    let city = formatAddressData(addressInfo["toCity"]);
    let state = formatAddressData(addressInfo["toState"]);
    let pincode = formatAddressData(addressInfo["pincode"]);
    if (address !== "") {
      toAddress.push(address);
    }
    if (locality !== "") {
      toAddress.push(locality);
    }
    if (city !== "") {
      toAddress.push(city);
    }
    if (state !== "") {
      toAddress.push(state);
    }
    if (pincode !== "") {
      toAddress.push(pincode);
    }
    return toAddress.join(", ");
  };
  const JSX = (
    <div className="row mb-2">
      <div className="col-sm-10">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-5">
            <h6 className="heading-label">From </h6>
            <p className="move-address">{getFromAddress(fromAddress)}</p>
          </div>
          <div className="col-sm-12 col-md-2 arrow-container">
            <div>
              <img
                src={
                  config.customerPortal +
                  "/includes/img/customerDashboard/move_arrow.png"
                }
                className="img-fluid"
                alt="..."
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-5">
            <h6 className="heading-label">To </h6>
            <p className="move-address">{getToAddress(toAddress)}</p>
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-2">
        <h6 className="heading-label">Request# </h6>
        <button
          className="estimate-btn"
          onClick={() => {
            downloadInqury(estimateDetails);
          }}
        >
          <b>{estimateId}</b>
        </button>
      </div>
    </div>
  );
  return JSX;
}
export function ActionButtons(props) {
  const { showMoveDetailsFn, showVendorQuotesFn, data } = props;
  const JSX = (
    <>
      <div className="d-flex flex-row">
        <button
          onClick={showMoveDetailsFn}
          className="btn btn-sm w-100 light-btn"
        >
          View Move Details
        </button>
        <button
          onClick={() => {
            //if quotes > 0 check
            showVendorQuotesFn();
          }}
          className="btn btn-primary btn-sm ml-2 w-100"
        >
          {data.custom_status}
        </button>
      </div>
    </>
  );
  return JSX;
}
